// extracted by mini-css-extract-plugin
module.exports = {"clientReferralWrapper":"ClientReferral_clientReferralWrapper__3L3C3","title":"ClientReferral_title__2-4OP","itemText":"ClientReferral_itemText__Fo_u7"};